/*
 * Copyright (c) Nexign, JSC, 2019-2023.
 */
/**
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @author Evgeniy Naumov
 * @version 1.25.1
 * @since 1.0.0
 */
import styled from 'styled-components';

import { colors, fonts } from '../../../../theme';
import { IAttrStyled } from '../../../../types/globalTypes';

interface ILinkContainerStyledProps {
    className?: string;
    dataName?: string;
    disabled?: boolean;
    inner?: boolean;
    tabIndex?: number;
}

export const LinkTextBlock = styled.span`
    ${fonts.textLink};
    text-decoration: none;
`;

export const LinkContainerStyled = styled.span.attrs((props: ILinkContainerStyledProps) => ({
    className: `link ${props.className} ${props.disabled ? 'disabled' : ''}`,
    dataName: props.dataName,
    tabIndex: props.tabIndex ?? 0,
}))<ILinkContainerStyledProps & IAttrStyled>`
    cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
    outline: none;

    ${LinkTextBlock} {
        margin-bottom: 1px;
        border-bottom-color: ${colors.linkDefaultColorHover};
        border-bottom-width: 1px;
    }

    &:hover ${LinkTextBlock}, &:focus ${LinkTextBlock} {
        border-bottom-style: ${({ disabled, inner }) => (disabled ? 'none' : inner ? 'dashed' : 'solid')};
    }

    &.disabled a {
        pointer-events: none;
    }

    a {
        ${fonts.textLink};
        text-decoration: none;
    }

    ${LinkTextBlock} {
        ${({ disabled }) => (disabled ? `color: ${colors.linkDefaultColorDisabled};` : '')}
    }
`;

export const LinkArrowContainer = styled.div`
    display: inline-block;
    margin-left: 16px;
`;
